import { actions, selectors } from 'data'
import React from 'react'
import { connect, ConnectedProps } from 'react-redux'

import Veriff from './template'

export type PropsType = ConnectedProps<typeof connector>

class VeriffContainer extends React.Component<PropsType> {
  componentDidMount() {
    this.props.getVeriffMetadata()
  }

  render() {
    return <Veriff {...this.props} />
  }
}

const mapStateToProps = (state) => ({
  veriffMetadata: selectors.app.getVeriffMetadata(state),
  veriffMetadataError: selectors.app.getVeriffMetadataError(state)
})

const mapDispatchToProps = (dispatch) => ({
  getVeriffMetadata: () => {
    dispatch(actions.app.getVeriffMetadata())
  },
  hideModal: () => {
    dispatch(actions.app.hideModal('TIER_TWO'))
  },
  setModalLargescreen: (flag) => {
    dispatch(actions.app.setModalLargescreen(flag))
  },
  syncVeriff: () => {
    dispatch(actions.tierTwo.syncVeriff())
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(VeriffContainer)
